module.exports = require("./ckb-IR.d.ts");